import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AuthenticationGuard } from '../core/authentication.guard';
import { AuthCallbackComponent } from './auth-callback.component';
import { MsalGuard } from '@azure/msal-angular';
import { ErrorComponent } from './error/error.component';
import { AppContentComponent } from './app-content/app-content.component';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: ':tenantId',
    component: AppContentComponent,
    children: [
      {
        path: 'admin/brands',
        loadChildren: () => import('./admin/brand/brand.module').then(m => m.BrandModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/batches',
        loadChildren: () => import('./admin/batch/batch.module').then(m => m.BatchModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/client',
        loadChildren: () => import('./admin/client/client.module').then(m => m.ClientModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'communications',
        loadChildren: () => import('./admin/communication/communication.module').then(m => m.CommunicationModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./admin/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/donothonorexclusions',
        loadChildren: () => import('./admin/donothonorexclusions/donothonorexclusions.module').then(m => m.DoNotHonorExclusionsModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/hcps',
        loadChildren: () => import('./admin/hcp/hcp.module').then(m => m.HcpModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/offers',
        loadChildren: () => import('./admin/offer/offer.module').then(m => m.OfferModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard],
      },
      {
        path: 'orders',
        loadChildren: () => import('./admin/order/order.module').then(m => m.OrderModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard],
      },
      {
        path: 'admin/products',
        loadChildren: () => import('./admin/product/product.module').then(m => m.ProductModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/customers',
        loadChildren: () => import('./admin/customer/customer.module').then(m => m.CustomerModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/programs',
        loadChildren: () => import('./admin/program/program.module').then(m => m.ProgramModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/roles',
        loadChildren: () => import('./admin/role/role.module').then(m => m.RoleModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/users',
        loadChildren: () => import('./admin/user/user.module').then(m => m.UserModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard],
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard],
      },
      {
        path: 'admin/pharmacists',
        loadChildren: () => import('./admin/pharmacist/pharmacist.module').then(m => m.PharmacistModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/clientlevelblackouthold',
        loadChildren: () => import('./admin/clientlevelblackouthold/clientlevelblackouthold.module').then(m => m.ClientlevelblackoutholdModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'admin/certificates',
        loadChildren: () => import('./admin/certification/certification.module').then(m => m.CertificationModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
      {
        path: 'support',
        loadChildren: () => import('./admin/support/support.module').then(m => m.SupportModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })]
})
export class AppRoutingModule { }

